@if (canSeeHarvestAdd || canSeeGroupAdd || canSeeAddEventBtn) {
  <button mat-raised-button class="gridbtn"
    [matMenuTriggerFor]="addmenu" aria-label="Example icon-button with a menu">
    <mat-icon>add</mat-icon>
  </button>
}
<mat-menu #addmenu="matMenu">
  @if (canSeeHarvestAdd) {
    <button mat-menu-item (click)="addHarvest()">
      <mat-icon fontSet="material-symbols-outlined">potted_plant</mat-icon>
      <span>Harvest</span>
    </button>
  }
  @if (canSeeGroupAdd) {
    <button mat-menu-item (click)="addGroup()">
      <mat-icon>splitscreen</mat-icon>
      <span>Task Group</span>
    </button>
  }
  @if (canSeeAddEventBtn) {
    <button mat-menu-item (click)="addEvent()">
      <mat-icon>event</mat-icon>
      <span>Event</span>
    </button>
  }
  <!-- Apply Workflow Button  -->
  <app-apply-workflow-btn [showApplyToGroupButton]="true"></app-apply-workflow-btn>
</mat-menu>